<mat-action-list>
	<button mat-list-item *ngFor="let seancesWithMessage of seancesWithMessages"
		(click)="onMessageClicked(seancesWithMessage)">{{seancesWithMessage.message}}</button>
</mat-action-list>